module.exports = __webpack_public_path__ + "static/media/filter-defs.4664c9bb.svg";